export type BaseSuggestion = {
  value: string; // for autocomplete, this is the value that will be used to select the suggestion
  display: string; // this is the text that will be displayed in the suggestion list
};

export interface FeatureSuggestion extends BaseSuggestion {
  type: 'featureToggle';
}

export interface RouteSuggestion extends BaseSuggestion {
  path: string;
  type: 'route';
}

export interface SubjectSuggestion extends BaseSuggestion {
  subjectId: string;
  type: 'subject';
}

export interface CustomSuggestion<T> extends BaseSuggestion {
  data: T;
  type: 'custom';
}

export type Suggestion<T = unknown> =
  | FeatureSuggestion
  | RouteSuggestion
  | SubjectSuggestion
  | CustomSuggestion<T>;

export interface Features {
  [key: string]: boolean;
}

// Type guard functions
export const isFeatureSuggestion = (
  suggestion: Suggestion,
): suggestion is FeatureSuggestion => {
  return 'type' in suggestion && suggestion.type === 'featureToggle';
};

export const isRouteSuggestion = (
  suggestion: Suggestion,
): suggestion is RouteSuggestion => {
  return 'path' in suggestion;
};

export const isSubjectSuggestion = (
  suggestion: Suggestion,
): suggestion is SubjectSuggestion => {
  return 'type' in suggestion && suggestion.type === 'subject';
};
